import { FC, ReactElement, ReactNode } from 'react';
import { EntryGuard } from 'ia-react-core/~/interfaces/EntryGuard';
import { ExitGuard } from 'ia-react-core/~/interfaces/ExitGuard';

export interface StepProps {
  /** The content of the step. Alternative to `Component` prop. */
  children?: ReactNode | (() => ReactNode);
  /** The name of step. Used as the key where the step's data is saved. */
  name: string;
  /** Functions that control the entry of a step. */
  entryGuards?: EntryGuard[];
  /** Functions that control the exit of a step. */
  exitGuards?: ExitGuard[];
  /** Route path of the step. If no path is used, the step won't be using any routing. */
  path?: string | string[] | { fr: string | string[]; en: string | string[] };
  /** Whether if the path should be matched exactly or not. True by default. */
  exact?: boolean;

}

export interface StepStatics {
  type: Symbol;
}

const Step: FC<StepProps> & StepStatics = ({ children }) => children as ReactElement;

Step.type = Symbol('Step');

/**
 * @component
 * @visibleName Step
 */
export default Step;
